import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GlobalService } from '../global/global.service';
/**
 * Rules access for the whole plattform this
 * is the place to check if user has access to
 * a page in general
 */
@Injectable({
  providedIn: 'root',
})
export class PermissionGuard {
  private globalService = inject(GlobalService);
  private httpClient = inject(HttpClient);
  private router = inject(Router);

  user: any;
  private isServer = this.globalService.isServer();

  ACCESS_CONTROL_PATH = '/services/access-control';

  public canActivate = (route: ActivatedRouteSnapshot): any => {
    const permission = route.data['permission'] as string;
    if (permission) {
      return this.checkPermission(permission);
    }
    return false;
  };

  public canActivateChild = (route: ActivatedRouteSnapshot): any => {
    const permission = route.data['permission'] as string;
    if (permission) {
      return this.checkPermission(permission);
    }
    return false;
  };

  private checkPermission(permission) {
    if (!this.isServer) {
      return this.httpClient.get<any>(`${this.ACCESS_CONTROL_PATH}/permissions/check/${permission}`).pipe(
        map((res) => {
          console.log('Can activate res:', res);
          if (res.status === 'OK') {
            return true;
          }
          this.router.navigate(['/']);
          return false;
        }),
        catchError(() => {
          this.router.navigate(['/']);
          return of(false);
        }),
      );
    }
    this.router.navigate(['/']);
    return false;
  }
}
